var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-check-container" }, [
    _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "banner-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "gradient-btn green-btn",
                attrs: { type: "success", icon: "el-icon-download" },
                on: { click: _vm.handleExportExcel },
              },
              [_vm._v("\n          Xuất Excel đối soát\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "ai-stats-grid" }, [
      _c("div", { staticClass: "stat-card blue" }, [
        _vm._m(1),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Tổng giao dịch trên SePay (Trang này)"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.stats.sepayCount)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "stat-card green" }, [
        _vm._m(2),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Tổng giao dịch trên OneKids (Trang này)"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.stats.onekidsCount)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "stat-card purple" }, [
        _vm._m(3),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Lệch giao dịch (Đối chiếu)"),
          ]),
          _c(
            "h3",
            {
              staticClass: "stat-value",
              class: _vm.stats.diffCount !== 0 ? "diff-warning" : "",
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.stats.diffCount) + " GD\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "glass-card mb-4" },
      [
        _c(
          "el-form",
          {
            staticClass: "modern-filter-form",
            attrs: { inline: true, model: _vm.dataFilter },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "Khoảng ngày đối soát" } },
              [
                _c("el-date-picker", {
                  staticClass: "modern-date-picker",
                  attrs: {
                    type: "daterange",
                    format: "dd-MM-yyyy",
                    "unlink-panels": "",
                    clearable: false,
                    "range-separator": "-",
                    "start-placeholder": "Bắt đầu",
                    "end-placeholder": "Kết thúc",
                  },
                  on: { change: _vm.findAllData },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "filter-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.findAllData },
                  },
                  [_vm._v("Lọc dữ liệu")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "glass-card table-container" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading.table,
                expression: "loading.table",
              },
            ],
            ref: "multipleTable",
            staticClass: "modern-table",
            attrs: {
              data: _vm.dataTable,
              "element-loading-text": "Đang tải danh sách bộ đếm...",
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(255,255,255,0.7)",
              border: "",
              "highlight-current-row": "",
              "max-height": _vm.tableMaxHeight,
              "summary-method": _vm.getSummaries,
              "show-summary": "",
            },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "55", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "STT",
                width: "60",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ngày đối soát",
                "min-width": "160",
                align: "center",
                prop: "date",
                fixed: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "date-text" }, [
                        _vm._v(_vm._s(_vm.formatDate(row.date))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng giao dịch vào (SePay)",
                "min-width": "200",
                align: "center",
                prop: "transactionIn",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge green" }, [
                        _vm._v(_vm._s(row.transactionIn || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng giao dịch ra (SePay)",
                "min-width": "200",
                align: "center",
                prop: "transactionOut",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge red" }, [
                        _vm._v(_vm._s(row.transactionOut || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng số giao dịch (SePay)",
                "min-width": "200",
                align: "center",
                prop: "transaction",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge total" }, [
                        _vm._v(_vm._s(row.transaction || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng giao dịch vào (OneKids)",
                "min-width": "200",
                align: "center",
                prop: "transactionInOgv",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge green-light" }, [
                        _vm._v(_vm._s(row.transactionInOgv || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng giao dịch ra (OneKids)",
                "min-width": "200",
                align: "center",
                prop: "transactionOutOgv",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge red-light" }, [
                        _vm._v(_vm._s(row.transactionOutOgv || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tổng số giao dịch (OneKids)",
                "min-width": "200",
                align: "center",
                prop: "transactionOgv",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "count-badge total-light" }, [
                        _vm._v(_vm._s(row.transactionOgv || 0)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper mt-3 flex justify-center" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.dataFilter.page,
                "page-sizes": _vm.listSizePage,
                "page-size": _vm.dataFilter.limit,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.totalPage,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentPageChange,
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.dataFilter, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.dataFilter, "page", $event)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-odometer" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("BỘ ĐẾM GIAO DỊCH HỆ THỐNG"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Đối chiếu tổng số giao dịch đã nhận giữa cổng thanh toán SePay và hệ thống quản lý trường học OneKids."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-refresh-left" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-document-copy" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }